import { render, staticRenderFns } from "./CollectHandelPeripheralTable.vue?vue&type=template&id=7d73579f"
import script from "./CollectHandelPeripheralTable.vue?vue&type=script&lang=js"
export * from "./CollectHandelPeripheralTable.vue?vue&type=script&lang=js"
import style0 from "./CollectHandelPeripheralTable.vue?vue&type=style&index=0&id=7d73579f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports